import React from 'react';
import { stringifyDateToISO8601 } from '../../util/dates';
import { getCreditsLabel } from '../../credits-config';
import css from './CreditsPurchaseHistory.css';

const CreditsPurchaseHistory = ({ creditsHistoryAvailable }) => {
    return (
        <>
            <div className={css.creditsPurchaseHistory}>
                <h3>Historie</h3>
                <section>
                    {creditsHistoryAvailable
                        .sort(
                            (a, b) =>
                                new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
                        )
                        .map((creditItem, index) => (
                            <div key={index} className={css.creditTxItem}>
                                <p>
                                    {stringifyDateToISO8601(
                                        new Date(creditItem.createdAt),
                                        'DD.MM.YYYY'
                                    )}
                                </p>
                                <p>{getCreditsLabel(creditItem)}</p>
                                <p>
                                    {!!creditItem.action ? '+' : '-'} {creditItem.total}
                                </p>
                            </div>
                        ))}
                </section>
            </div>
            <p className={css.sidenote}>
                Einige Gutschriften oder Belastungen, z. B. bei Ablauf von Credits, werden
                möglicherweise nicht vollständig in der Historie aufgeführt.
            </p>
        </>
    );
};

export default CreditsPurchaseHistory;
